export default __webpack_public_path__ + "static/media/Artist_cover.b335bc73.png";